import type { ModuleId, OverrideMode } from '@tahi/core';
import { ApiError, apiFetch, type Fetcher } from './api';
import type { LocalDb } from './localDb';
import { getState, setState } from './syncState';

export type Role = 'user' | 'super_admin';

/** Same shape as the Worker's ModuleView (`apps/worker/src/modules/view.ts`). */
export interface ModuleView {
  id: ModuleId;
  enabled: boolean;
  override: OverrideMode;
  usable: boolean;
  managedByAdmin: boolean;
  alwaysOn: boolean;
}

/** GET /api/me (`apps/worker/src/routes/me.ts`). */
export interface MeResponse {
  user: { id: string; email: string; name: string; role: Role };
  settings: { inviteOnly: boolean; billingLive: boolean };
  modules: ModuleView[];
}

/** Fetches /api/me and caches it locally, so module access still works offline. */
export async function loadMe(db: LocalDb, fetcher?: Fetcher): Promise<MeResponse | null> {
  try {
    const me = await apiFetch<MeResponse>('/api/me', { fetcher });
    await setState(db, 'me', JSON.stringify(me));
    return me;
  } catch (err) {
    if (err instanceof ApiError && err.status === 401) throw err;
    const cached = await getState(db, 'me');
    return cached ? (JSON.parse(cached) as MeResponse) : null;
  }
}
